import { jsx as p } from "react/jsx-runtime";
import { MenuButton as g } from "@headlessui/react";
import { DotsIcon as i } from "../../icons/dots-icon.mjs";
import { twMerge as t } from "tailwind-merge";
function c({
  active: r,
  isFetching: n,
  iconClassName: a,
  menuButtonClassName: e,
  dataTestAttributes: u,
  children: o,
  ...m
}) {
  return /* @__PURE__ */ p(
    g,
    {
      disabled: n,
      className: t(
        !o && "hover:bg-brand-primary focus-ring group h-[30px] rounded-lg px-3 py-1 transition-colors lg:h-[20px]",
        !o && (r ? "bg-brand-primary" : "bg-background-primary"),
        n && "pointer-events-none animate-pulse",
        e
      ),
      ...u,
      ...m,
      children: typeof o == "function" ? (s) => o({ ...s, active: r }) : o ?? /* @__PURE__ */ p(
        i,
        {
          className: t(
            "group-hover:fill-background-secondary",
            r && "fill-background-secondary",
            a
          )
        }
      )
    }
  );
}
export {
  c as ActionMenuButtonWrapper
};
